import { SET_BANNER_VIEW } from '../constants';

const initialState = {};
export default function mainBannerReducer(state = initialState, action) {
  switch (action.type) {
    case SET_BANNER_VIEW: {
      const eq = action.payload;
      const mappedBanners = (state.banners || []).map((banner, index) => {
        if (eq === index) {
          banner.isView = true;
        }
        return banner;
      });
      state.banners = mappedBanners;
      return state;
    }
    default:
      return state;
  }
}
